/* eslint-env jest */
import classYearFor from './classYear';

describe('classYearFor -- the year "CLASS OF" prints on the graduate magnet', () => {
  it('reads the roster-derived grad year the API serves', () => {
    expect(classYearFor({ student: { gradYear: 2027 } })).toBe(2027);
  });

  it('accepts the year as a string, which is how a JSON attribute can arrive', () => {
    expect(classYearFor({ student: { gradYear: '2027' } })).toBe(2027);
  });

  it('falls back to the senior sitting folder when the roster grade is not a number', () => {
    const poses = [{ folder: 'fall2027' }, { folder: 'seniors2027' }];
    expect(classYearFor({ student: { gradYear: null }, poses })).toBe(2027);
  });

  it('prefers the roster over the folder when both are known', () => {
    expect(classYearFor({ student: { gradYear: 2028 }, poses: [{ folder: 'seniors2027' }] })).toBe(2028);
  });

  it('does not read a year out of a non-senior folder', () => {
    expect(classYearFor({ student: {}, poses: [{ folder: 'fall2027' }, { folder: 'sportsfall2027' }] })).toBeNull();
  });

  it('answers null -- not a guess -- when nothing is known', () => {
    expect(classYearFor({})).toBeNull();
    expect(classYearFor({ student: null, poses: [null, {}] })).toBeNull();
    expect(classYearFor({ student: { gradYear: 0 } })).toBeNull();
  });
});
